import React from 'react';

const DangerIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-danger" />
    </div>
  );
};

export default DangerIcon;
